import DOMPurify from "dompurify";

// Allow common safe formatting tags + links/images. Strip <script>, <iframe>, event handlers, etc.
const DEFAULT_CONFIG = {
  ALLOWED_TAGS: [
    "a", "b", "i", "em", "strong", "u", "s", "br", "p", "div", "span",
    "h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "li", "blockquote",
    "pre", "code", "hr", "table", "thead", "tbody", "tr", "td", "th",
    "img", "figure", "figcaption", "sub", "sup", "small",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "title", "style", "class", "width", "height"],
  // Note: DOMPurify automatically strips dangerous CSS (expression(), behavior:, javascript: in url(), etc.) even when 'style' is allowed.
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "button"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "onblur"],
};

/**
 * Sanitize untrusted HTML before rendering with dangerouslySetInnerHTML.
 * Defaults are safe for rich-text content (emails, proposals).
 */
export function sanitizeHtml(html, config = {}) {
  if (!html || typeof html !== "string") return "";
  return DOMPurify.sanitize(html, { ...DEFAULT_CONFIG, ...config });
}

/**
 * Convert HTML to plain text safely. Uses DOMParser instead of innerHTML
 * to avoid evaluating any inline scripts/event handlers, even in detached nodes.
 */
export function htmlToPlainText(html) {
  if (!html || typeof html !== "string") return "";
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return (doc.body?.textContent || "").trim();
  } catch {
    return "";
  }
}
